import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import {
  getUploadJobs,
  restoreProductMediaUploads,
  subscribeUploadJobs,
  type UploadJob,
} from "./productMediaUploadManager";

const ProductMediaUploadContext = createContext<UploadJob[]>([]);

export const ProductMediaUploadProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [jobs, setJobs] = useState<UploadJob[]>(() => getUploadJobs());
  useEffect(() => {
    void restoreProductMediaUploads();
    return subscribeUploadJobs(setJobs);
  }, []);
  return (
    <ProductMediaUploadContext.Provider value={jobs}>
      {children}
    </ProductMediaUploadContext.Provider>
  );
};

export const useProductMediaUploads = (productId?: string): UploadJob[] => {
  const jobs = useContext(ProductMediaUploadContext);
  return useMemo(() => {
    if (productId === undefined) {
      return jobs;
    }
    return jobs.filter((job) => job.productId === productId);
  }, [jobs, productId]);
};
